import React, { memo } from "react";

import SkeletonPlaceholder from "@/components/molecules/SkeletonPlaceholder";

import { Box } from "@/components/atoms/Box";
import { Stack } from "@/components/atoms/Stack";

/**
 * Props for SkeletonWatchlistView component
 */
interface Props {
  bgColor: string;
}

/**
 * Pure view component for watchlist skeleton
 * @param root0 - Component props
 * @param root0.bgColor - Background color value
 */
const SkeletonWatchlistView = ({ bgColor }: Props) => (
  <SkeletonPlaceholder>
    <Stack direction="horizontal" className="min-h-20 items-center gap-4 py-2">
      <Box
        className={`h-7 w-14 animate-pulse rounded-none opacity-70 ${bgColor}`}
      />
      <Box
        className={`h-8 flex-1 animate-pulse gap-2 rounded-none opacity-70 ${bgColor}`}
      />
      <Box
        className={`h-7 w-14 animate-pulse rounded-none opacity-70 ${bgColor}`}
      />
    </Stack>
  </SkeletonPlaceholder>
);

SkeletonWatchlistView.displayName = "SkeletonWatchlistView";

export default memo(SkeletonWatchlistView);
